<template>
    <div v-show="visible">
        <el-dialog title="回执详情" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="600px">
            
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.replayName" placeholder="回执人姓名"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.className" placeholder="班级名称"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                </div>
            </div>

            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="330"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border fit highlight-current-row>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="replayName" label="回执人姓名" width="100"></el-table-column>
                <el-table-column prop="className" label="班级名称" width="100"></el-table-column>
                <el-table-column prop="status" label="状态" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 1">
                            未回执
                        </div>
                        <div v-else-if="scope.row.replayType == 2">
                            已回执
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="readSign" label="阅读标记" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 1">
                            未读
                        </div>
                        <div v-else-if="scope.row.replayType == 2">
                            已读
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="replayCreate" label="回执时间" width="100"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>

<script>
    import http from '@/common/http';

    export default {
        name:"",
        data(){
            return{
                visible:false,
                loading:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    noticeId: "",
                    replayName: "",
                    className: ""
                },
                data:[]
            }
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(id){
                this.visible=true
                // 初始化执
                this.form.replayName = ""
                this.form.noticeId=id
                this.getData()
            },
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1)
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                let url  = this.noticeReleaseNamelistUrl
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    noticeId:this.form.noticeId,
                    replayName: this.form.replayName,
                    className: this.form.className
                };
                // console.log(data);
                this.loading=true
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                       this.data = res.data.list
                       this.common.total=res.data.total
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading = false
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/notice/noticeRelease/commentInfo.vue